import {
  GET_ALL_SETTINGS,
  ADD_SETTINGS,
  UPDATE_SETTINGS,
  UPDATE_STATUS_SETTINGS,
  DELETE_SETTINGS,
} from "../types";
import { setAlert } from "./alert";
import axios from "../../axios";
import Swal from "sweetalert2";
import { getErrorMessage } from "../../helpers/ErrorMessage";

export const getAllSettings = () => async (dispatch) => {
  try {
    const res = await axios.get("settings/all");
    if (res.data.code === 1) {
      dispatch({ type: GET_ALL_SETTINGS, payload: res.data.data });
    }
  } catch (error) {
    const errorMessage = getErrorMessage(error.response?.data);

    Swal.fire({
      title: "Error!",
      text: errorMessage,
      icon: "error",
    });
  }
};

export const addSettings = (formData, form) => async (dispatch) => {
  try {
    const res = await axios.post("settings/add", formData);
    if (res.data.code === 1) {
      dispatch({ type: ADD_SETTINGS, payload: res.data.data });
      form.resetFields();
      Swal.fire({
        title: "Success!",
        text: res.data.message,
        icon: "success",
      });
    } else {
      Swal.fire({
        title: "Warning!",
        text: res.data.message,
        icon: "warning",
      });
    }
  } catch (error) {
    const errorMessage = getErrorMessage(error.response?.data);

    Swal.fire({
      title: "Error!",
      text: errorMessage,
      icon: "error",
    });
  }
};

export const updateSettings = (formData) => async (dispatch) => {
  try {
    const res = await axios.post("settings/update", formData);
    if (res?.data.code === 1) {
      dispatch({ type: UPDATE_SETTINGS, payload: res.data.data });
      Swal.fire({
        title: "Success!",
        text: res.data.message,
        icon: "success",
      });
    } else {
      Swal.fire({
        title: "Warning!",
        text: res?.data.message,
        icon: "warning",
      });
    }
  } catch (error) {
    const errorMessage = getErrorMessage(error.response?.data);

    Swal.fire({
      title: "Error!",
      text: errorMessage,
      icon: "error",
    });
  }
};

export const updateSettingsStatus = (formData, form) => async (dispatch) => {
  try {
    const res = await axios.post("settings/update/status", formData);
    if (res.data.code === 1) {
      dispatch({
        type: UPDATE_STATUS_SETTINGS,
        payload: res.data.data,
      });
      form.resetFields();
      Swal.fire({
        title: "Success!",
        text: res.data.message,
        icon: "success",
      });
    } else {
      Swal.fire({
        title: "Warning!",
        text: res.data.message,
        icon: "warning",
      });
    }
  } catch (error) {
    const errorMessage = getErrorMessage(error.response?.data);

    Swal.fire({
      title: "Error!",
      text: errorMessage,
      icon: "error",
    });
  }
};

export const deleteSettings = (id) => async (dispatch) => {
  try {
    if (!id) {
      dispatch(setAlert("Please select any record", "warning"));
      return false;
    }
    const res = await axios.post(`settings/delete/${id}`);
    if (res.data.code === 1) {
      dispatch({ type: DELETE_SETTINGS, payload: { id } });
      dispatch(setAlert(res.data.message, "success"));
      Swal.fire({
        title: "Success!",
        text: res.data.message,
        icon: "success",
      });
    } else {
      dispatch(setAlert(res.data.message, "warning"));
      Swal.fire({
        title: "Warning!",
        text: res.data.message,
        icon: "warning",
      });
    }
  } catch (error) {
    dispatch(setAlert(error.message, "danger"));
    const errorMessage = getErrorMessage(error.response?.data);

    Swal.fire({
      title: "Error!",
      text: errorMessage,
      icon: "error",
    });
  }
};

// import Swal from "sweetalert2";
// import axios from "../../axios";
// import {  GET_SETTING, UPDATE_SETTING } from "../types";
// import { setAlert } from "./alert";

// export const getSettings = () => async (dispatch) => {
//   try {
//     const res = await axios.get("sett/get");
//     if (res.data.code === 1) {
//       dispatch({ type: GET_SETTING, payload: res.data.data });
//     }
//   } catch (err) {
//     dispatch(setAlert(err.message, "danger"));
//   }
// };

// export const updateSettings = (formData) => async (dispatch) => {
//   try {
//     const updatedFormData = {
//       id: formData._id,
//       ownerName: formData.ownerName,
//       ownerEmail: formData.ownerEmail,
//       ownerNo: formData.ownerNo,
//       ownerWpNo: formData.ownerWpNo,
//       returnDay: formData.returnDay,
//       orderAmt: formData.orderAmt,
//       suratCity: formData.suratCity,
//       stateGujarat: formData.stateGujarat,
//       countryIndia: formData.countryIndia,
//       termsCond: formData.termsCond,
//       privacyPolicy: formData.privacyPolicy,
//     };

//     const res = await axios.post("sett/update", updatedFormData);
//     if (res.data.code === 1) {
//       dispatch({ type: UPDATE_SETTING, payload: res.data.data });
//       Swal.fire({
//         title: 'Success!',
//         text: res.data.message,
//         icon: 'success',
//       });
//       dispatch(setAlert(res.data.message, "success"));
//     } else {
//       dispatch(setAlert(res.data.message, "warning"));
//       Swal.fire({
//         title: 'Warning!',
//         text: res.data.message,
//         icon: 'warning',
//       });
//     }
//   } catch (err) {
//     dispatch(setAlert(err.message, "danger"));
//     Swal.fire({
//       title: 'Error!',
//       text: err.message,
//       icon: 'error',
//     });
//   }
// };
